module.exports = __webpack_public_path__ + "img/1-2.52d75191.png";